import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface FieldProps {
  editField?: ReactNode;
  editing?: boolean;
  icon?: ReactNode;
  label: string;
  value: ReactNode;
}

export function Field({ label, value, editField, icon, editing = false }: FieldProps) {
  return (
    <Box
      sx={(theme) => ({
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        minHeight: '57px',
        px: 2,
      })}
    >
      <Box
        sx={{
          maxWidth: '150px',
          minWidth: '150px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <Typography
          variant="body1"
          title={label}
          sx={(theme) => ({
            color: theme.palette.text.secondary,
            fontWeight: 'bold',
            overflow: 'hidden',
            pr: 1,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          })}
        >
          {label}
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1,
            placeContent: 'space-between',
            width: '100%',
          }}
        >
          {editing && editField}

          {!editing && (
            <Typography
              title={typeof value === 'string' ? value : ''}
              variant="body1"
              sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {value}
            </Typography>
          )}

          {icon}
        </Box>
      </Box>
    </Box>
  );
}
